import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CORE_IMPORTS } from "../providers/module-providers";

@Component({
	standalone: true,
	selector: 'app-dialog',
	templateUrl: 'dialog.html',
	styleUrls: ['dialog.css'],
	imports: [CORE_IMPORTS]

})

export class DialogComponent implements OnInit {
	error: string;
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dialogRef: MatDialogRef<DialogComponent>,
	) { }

	ngOnInit(): void {
		this.error = this.data.error;
	}

	close(): void {
		this.dialogRef.close();
	}

}